import Content from "./CollapsibleContent.svelte"
import Root from "./CollapsibleRoot.svelte"
import Trigger from "./CollapsibleTrigger.svelte"

export type { CollapsibleContentProps } from "./CollapsibleContent.svelte"
export type { CollapsibleRootProps } from "./CollapsibleRoot.svelte"

export const Collapsible = {
  Content,
  Trigger,
  Root,
}
